"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryForm = void 0;
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var button_1 = require("../../action/button");
var datePicker_1 = require("../../input/datePicker");
var form_1 = require("../../input/form");
var select_1 = require("../../input/select");
var textInput_1 = require("../../input/textInput");
var readQuery_1 = require("../readQuery");
require("../../../index.css");
var queryType = [
    {
        key: "=",
        label: "=",
    },
    {
        key: ">",
        label: ">",
    },
    {
        key: "<",
        label: "<",
    },
    {
        key: "><",
        label: "><",
    },
];
function QueryForm(props) {
    var _this = this;
    var serverId = props.devSettings.server === "mongoServer" ? "_id" : "id";
    var formRef = (0, react_1.createRef)();
    var _a = (0, react_1.useState)([]), queryReferenceList = _a[0], setQueryReferenceList = _a[1];
    var _b = (0, react_1.useState)(""), queryReferenceSearch = _b[0], setQueryReferenceSearch = _b[1];
    var _c = (0, react_1.useState)({
        queryId: "",
        type: "=",
        value: "",
    }), queryInput = _c[0], setQueryInput = _c[1];
    (0, react_1.useEffect)(function () {
        var handleGetQueryReferenceList = function () { return __awaiter(_this, void 0, void 0, function () {
            var referenceOptionsList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        referenceOptionsList = [];
                        return [4 /*yield*/, Promise.all(props.model.map(function (eachModel) { return __awaiter(_this, void 0, void 0, function () {
                                var referenceRQ, query, referenceData, clonedQueryInput;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            if (!(queryInput.queryId === eachModel.id)) return [3 /*break*/, 3];
                                            if (!(eachModel.type === "reference" ||
                                                eachModel.type === "listReference")) return [3 /*break*/, 2];
                                            referenceRQ = new readQuery_1.ReadQuery({
                                                dbModule: props.dbModule,
                                                dbType: props.devSettings.server,
                                                dbCollection: (_a = eachModel.referenceSpaceId) !== null && _a !== void 0 ? _a : "",
                                                dbEndpoint: props.devSettings.dbEndpoint,
                                                dbAPIToken: props.devSettings.dbAPIToken,
                                            });
                                            query = [];
                                            if (queryReferenceSearch) {
                                                query.push({
                                                    type: "search",
                                                    value: queryReferenceSearch,
                                                    searchIds: [(_b = eachModel.referenceLabel) !== null && _b !== void 0 ? _b : serverId],
                                                });
                                            }
                                            return [4 /*yield*/, referenceRQ.call({
                                                    type: "list",
                                                    limit: 10,
                                                    query: query,
                                                })];
                                        case 1:
                                            referenceData = _c.sent();
                                            referenceData.data.map(function (eachData) {
                                                var _a, _b;
                                                var data = JSON.parse(JSON.stringify(eachData));
                                                var id = data[serverId];
                                                referenceOptionsList.push({
                                                    key: id,
                                                    label: (_b = data[(_a = eachModel.referenceLabel) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : id,
                                                });
                                                return "";
                                            });
                                            return [3 /*break*/, 3];
                                        case 2:
                                            if (eachModel.type === "date" && !queryInput.value) {
                                                clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                                                clonedQueryInput["value"] = (0, moment_1.default)().toISOString();
                                                setQueryInput(clonedQueryInput);
                                            }
                                            _c.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        setQueryReferenceList(referenceOptionsList);
                        return [2 /*return*/];
                }
            });
        }); };
        if (queryInput.type === "><" && !Array.isArray(queryInput.value)) {
            var clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
            var dates = [];
            dates.push((0, moment_1.default)().toISOString());
            dates.push((0, moment_1.default)().toISOString());
            clonedQueryInput["value"] = dates;
            setQueryInput(clonedQueryInput);
        }
        handleGetQueryReferenceList();
    }, [
        queryInput,
        queryReferenceSearch,
        props.dbModule,
        props.devSettings.dbEndpoint,
        props.devSettings.dbAPIToken,
        props.model,
        props.devSettings.server,
        serverId,
    ]);
    (0, react_1.useEffect)(function () {
        if (props.updateQuery) {
            setQueryInput(props.updateQuery);
        }
    }, [props.updateQuery]);
    var renderQueryOption = function () {
        var _a, _b;
        var queryOptionList = [];
        var type = (_b = (_a = props.model.find(function (eachDataStucture) { return eachDataStucture.id === queryInput.queryId; })) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : "string";
        if (type === "date") {
            queryOptionList = queryType;
        }
        else {
            // Filter out the item with key "><" from queryType
            queryOptionList = queryType.filter(function (option) { return option.key !== "><"; });
        }
        return queryOptionList;
    };
    var renderQueryModalContent = function () {
        var _a, _b;
        var queryValueInput = [];
        var formInputRef = Object.values(queryInput).map(function () { return (0, react_1.createRef)(); });
        var modelType = (_b = (_a = props.model.find(function (eachModel) { return eachModel.id === queryInput.queryId; })) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : "string";
        switch (modelType) {
            case "listReference":
            case "reference":
                queryValueInput.push(react_1.default.createElement(select_1.Select, { id: "value", ref: formInputRef[2], value: queryInput.value, label: "Value", options: queryReferenceList !== null && queryReferenceList !== void 0 ? queryReferenceList : [], onSearch: function (value) {
                        setQueryReferenceSearch(value);
                    }, onChange: function (value) {
                        var clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                        clonedQueryInput["value"] = value;
                        setQueryInput(clonedQueryInput);
                    } }));
                break;
            case "date":
                queryValueInput.push(react_1.default.createElement(datePicker_1.InputDatePicker, { id: "value", ref: formInputRef[2], value: queryInput.value
                        ? (0, moment_1.default)(queryInput.value).toDate()
                        : (0, moment_1.default)().toDate(), onChange: function (id, date) {
                        var clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                        clonedQueryInput[id] = date
                            ? (0, moment_1.default)(date).toISOString()
                            : undefined;
                        setQueryInput(clonedQueryInput);
                    }, showTime: true }));
                break;
            default:
                queryValueInput.push(react_1.default.createElement(textInput_1.TextInput, { id: "value", ref: formInputRef[2], value: queryInput.value, label: "Value", type: "text", placeholder: "eg. Type", onChange: function (e) {
                        var clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                        clonedQueryInput[e.target.id] = e.target.value;
                        setQueryInput(clonedQueryInput);
                    } }));
                break;
        }
        if (queryInput.type === "><") {
            queryValueInput.pop();
            queryValueInput.push(react_1.default.createElement(datePicker_1.InputDatePicker, { id: "value", ref: formInputRef[2], range: true, startDate: (0, moment_1.default)(queryInput.value[0]).toDate(), endDate: (0, moment_1.default)(queryInput.value[1]).toDate(), onChange: function (id, date, type) {
                    var clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                    if (type === "start")
                        clonedQueryInput[id][0] = (0, moment_1.default)(date).toISOString();
                    else
                        clonedQueryInput[id][1] = (0, moment_1.default)(date).toISOString();
                    setQueryInput(clonedQueryInput);
                }, showTime: true }));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(form_1.Form, { ref: formRef, refList: formInputRef, handleComplete: function () {
                    return props.handleQueryOnComplete
                        ? props.handleQueryOnComplete(queryInput)
                        : [];
                }, className: "grid grid-cols-1 gap-5 mt-6 pb-28" },
                react_1.default.createElement(select_1.Select, { id: "queryId", ref: formInputRef[0], value: queryInput.queryId, label: "Column ID", options: props.renderReferenceLabelOptions("", true), onChange: function (value) { return __awaiter(_this, void 0, void 0, function () {
                        var clonedQueryInput;
                        return __generator(this, function (_a) {
                            clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                            clonedQueryInput["queryId"] = value;
                            clonedQueryInput["value"] = "";
                            setQueryInput(clonedQueryInput);
                            return [2 /*return*/];
                        });
                    }); } }),
                react_1.default.createElement(select_1.Select, { id: "type", ref: formInputRef[1], value: queryInput.type, label: "Condition", options: renderQueryOption(), onChange: function (value) {
                        var clonedQueryInput = JSON.parse(JSON.stringify(queryInput));
                        clonedQueryInput["type"] = value;
                        clonedQueryInput["value"] = "";
                        setQueryInput(clonedQueryInput);
                    } }),
                queryValueInput),
            react_1.default.createElement("div", { className: "flex flex-row justify-end pt-4" },
                react_1.default.createElement(button_1.Button, { className: "mt-4", text: "Back", size: "small", type: "light", onClick: props.handleCloseForm }),
                react_1.default.createElement(button_1.Button, { className: "mt-4 ml-4", text: props.updateQuery ? "Update" : "Add", size: "small", type: "normal", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, ((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit())];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }))));
    };
    return renderQueryModalContent();
}
exports.QueryForm = QueryForm;
//# sourceMappingURL=index.js.map